import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import moment from 'moment'
import _ from 'lodash'

Vue.use(VeeValidate)

Validator.installDateTimeValidators(moment)

Vue.mixin({
  methods: {
    /**
     * Clears validation errors for a given scope.
     *
     * @param string scope
     *
     * @return void
     */
    clearValidationErrors (scope) {
      if (scope === undefined) {
        for (scope in this.$validator.$scopes) {
          this.errors.clear(scope)
        }
      } else {
        this.errors.clear(scope)
      }
    },

    /**
     * Validates all input fields for all scopes.
     *
     * @return Promise
     */
    validateAll () {
      return this.$validator.validateScopes().then(passed => {
        if (passed) {
          return Promise.resolve()
        }

        return Promise.reject()
      })
    },

    /**
     * Validates all input fields for given scope.
     *
     * @return Promise
     */
    validateScope (scope) {
      return this.$validator.validateAll(scope).then(passed => {
        if (passed) {
          return Promise.resolve()
        }

        return Promise.reject()
      })
    },

    /**
     * Validate a given field.
     *
     * @param string name
     * @param string value
     * @param string scope
     *
     * @return Promise
     */
    validate (name, value, scope) {
      return this.$validator.validate(name, value, scope).then(validationResult => {
        if (!validationResult) {
          return Promise.reject('Validation has failed.')
        }

        return Promise.resolve('Validation succeeded.')
      })
    },

    /**
     * Attach rules to a given field.
     *
     * @param string name
     * @param string rules
     * @param object options
     *
     * @return void
     */
    attachRules (name, rules, options = {}) {
      this.$validator.attach(name, rules, options)
    }
  }
})

Validator.extend('required_date', {
  getMessage: field => `The ${field} field is required.`,
  validate (value) {
    let [year, month, day] = _.map(value.split('-'), value => _.toNumber(value))

    return year > 0 && month > 0 && day > 0
  }
})



// WEBPACK FOOTER //
// ./src/utils/validation.js